module.exports = __webpack_public_path__ + "img/card-multi-tool-img.418b90ba.webp";